export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        if (!this.importResult) {
            this.$state.go('^', {}, {location: 'replace'})
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/import-users/upload-result/upload-result.controller.js